import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Back arrow glyph, 24px. */
export const SearchComboboxArrowLeftIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={24} {...props}>
        <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Back arrow glyph, 24px. */
export const SearchComboboxArrowLeftIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={24} {...props}>
        <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
